import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { environment } from '@env';

@Component({
    selector: 'app-legal-pages',
    templateUrl: './legal-pages.component.html',
    styleUrls: ['./legal-pages.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatProgressSpinner,
    ]
})
export class LegalPagesComponent implements OnInit {

  type;
  language;
  text = '';
  loadingData = true;
  sanitizedText: SafeHtml = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(async params => {
      this.type = params.get('type');
      this.language = params.get('language');

      // Build URL
      let url = `${environment.apiURLV2}/v2/public/privacy-terms/read-privacy-terms?`;
      if (this.type !== undefined && this.type !== null) {
        url += `type=${encodeURIComponent(this.type)}&`;
      }
      if (this.language !== undefined && this.language !== null) {
        url += `language=${encodeURIComponent(this.language)}&`;
      }
      url = url.replace(/[?&]$/, '');

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        // Extract styles from head and body content from the full HTML document
        let htmlContent = data.data;
        let finalContent = '';

        // Extract styles from head
        const styleMatch = htmlContent.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
        if (styleMatch) {
          finalContent += `<style>${styleMatch[1]}</style>`;
        }

        // Extract body content
        const bodyMatch = htmlContent.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) {
          finalContent += bodyMatch[1];
        } else {
          // If no body tags found, use the content as-is (fallback)
          finalContent += htmlContent;
        }

        // Fix common character encoding issues (Windows-1252 to UTF-8)
        finalContent = finalContent
          .replace(/â€œ/g, '"')     // Left double quotation mark
          .replace(/â€\u009d/g, '"') // Right double quotation mark
          .replace(/â€™/g, '\'')     // Right single quotation mark
          .replace(/â€"/g, '–')     // En dash
          .replace(/â€"/g, '—')     // Em dash
          .replace(/Â /g, ' ')      // Non-breaking space
          .replace(/â€¢/g, '•')     // Bullet point
          .replace(/â€¦/g, '…')     // Ellipsis
          .replace(/â‚¬/g, '€')     // Euro symbol
          .replace(/Â§/g, '§')      // Section symbol
          .replace(/Â©/g, '©')      // Copyright symbol
          .replace(/Â®/g, '®')      // Registered trademark
          .replace(/â„¢/g, '™')     // Trademark symbol
          .replace(/◆/g, '◆')       // Keep diamond symbols
          .replace(/●/g, '•')       // Convert filled circles to bullets
          .replace(/\uFFFD/g, '')   // Remove replacement characters
          .replace(/ï¿½/g, '');     // Remove replacement characters

        this.sanitizedText = this.sanitizer.bypassSecurityTrustHtml(finalContent);

        // Use setTimeout to ensure change detection completes
        setTimeout(() => {
          this.loadingData = false;
        }, 0);
      } catch (error) {
        console.error('Privacy terms error:', error);
        alert(error instanceof Error ? error.message : 'An error occurred');
      }
    });
  }

}
